import Link from 'next/link';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import useTranslation from 'next-translate/useTranslation';

interface SeeAllLink {
  viewAllURL: string;
}

const SeeAllLink = ({ viewAllURL }: SeeAllLink) => {
  const { t } = useTranslation('common');
  return (
    <Link href={viewAllURL}>
      <a
        className={ivclass(
          'iv-text-black-50',
          'iv-font-semibold',
          'hover:iv-text-blue',
          'iv-pr-15 lg:iv-pr-[38px] sm:iv-pr-[0]',
          'sm:iv-text-body-xl sm:iv-m-body-xl',
          'iv-group',
        )}
      >
        {t('See all')}
        <ImageComponent
          elementype="native"
          loading="lazy"
          alt={'chevron'}
          width={14}
          height={8}
          src={`${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/header-icons/angle-right-bold.svg`}
          className={ivclass(
            'iv-inline-block',
            'iv-px-4',
            'group-hover:iv-hidden',
          )}
        />
        <ImageComponent
          elementype="native"
          loading="lazy"
          width={14}
          height={8}
          alt={'hover-chevron'}
          src={`${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/header-icons/angle-right-bold-blue.svg`}
          className={ivclass(
            'iv-px-4',
            'group-hover:iv-inline-block',
            'iv-hidden',
          )}
        />
      </a>
    </Link>
  );
};

export default SeeAllLink;
